import { defaultHttpClient } from '../../httpClient';

/**
 * - 리뷰 좋아요 취소 API
 */
export const deleteReviewLike = (reviewSno: number) => {
  return defaultHttpClient
    .request<void>({
      method: 'DELETE',
      url: `/api/v2/reviews/${reviewSno}/like/`,
    })
    .then(() => undefined);
};